import {AppContext} from '../../../../app-context';
import {exportDataAsExcel} from '../../../../common/upload/excel.utils';
import moment from 'moment';

export interface BuildingTypeBackfillProposalRow {
    organisationId: string;
    organisationName: string;
    locationId: string;
    locationName: string;
    address: string;
    objectNumber: string;
    buildingCode: string;
    cadastreId: string;
    activeMeterCount: number;
    sourceBuildingType: string;
    proposedBuildingTypeId: string;
    proposedBuildingTypeCode: string;
    proposedBuildingTypeName: string;
    status: string;
    confidence: string;
    matchMethod: string;
}

const labels = {
    en: {
        headers: ['Organisation', 'Location', 'Address', 'Object number', 'Building code', 'Location ID',
            'BAG addressable object ID', 'Active meters', 'EP-Online building type',
            'Proposed WEii building type', 'Proposed building type code', 'Proposal status', 'Confidence',
            'Match method', 'Approved building type code', 'Reviewer note'],
        fileName: 'building-type-backfill-proposal',
        statuses: {
            SAFE_TO_APPLY: 'Safe to apply', REVIEW_REQUIRED: 'Review required',
            SOURCE_MISSING: 'Source missing', TARGET_NOT_FOUND: 'Target building type not found'
        },
        confidence: {HIGH: 'High', NONE: 'None'},
        matchMethods: {
            EXACT_CODE_OR_NAME: 'Exact code or name', APPROVED_ALIAS: 'Approved mapping', NONE: 'None'
        }
    },
    nl: {
        headers: ['Organisatie', 'Locatie', 'Adres', 'Objectnummer', 'Objectnaam', 'Locatie-ID',
            'BAG verblijfsobject-ID', 'Actieve meters', 'EP-Online-gebouwtype',
            'Voorgesteld WEii-gebouwtype', 'Voorgestelde gebouwtypecode', 'Voorstelstatus', 'Betrouwbaarheid',
            'Koppelmethode', 'Goedgekeurde gebouwtypecode', 'Opmerking beoordelaar'],
        fileName: 'voorstel-aanvullen-gebouwtypen',
        statuses: {
            SAFE_TO_APPLY: 'Veilig toepasbaar', REVIEW_REQUIRED: 'Handmatige controle nodig',
            SOURCE_MISSING: 'Bron ontbreekt', TARGET_NOT_FOUND: 'Doelgebouwtype niet gevonden'
        },
        confidence: {HIGH: 'Hoog', NONE: 'Geen'},
        matchMethods: {
            EXACT_CODE_OR_NAME: 'Exacte code of naam', APPROVED_ALIAS: 'Goedgekeurde koppeling', NONE: 'Geen'
        }
    }
};

export function buildingTypeBackfillProposalRows(rows: BuildingTypeBackfillProposalRow[], language = 'en'): any[][] {
    const locale = language === 'nl' ? labels.nl : labels.en;
    return [locale.headers, ...rows.map(row => [
        row.organisationName, row.locationName, row.address, row.objectNumber, row.buildingCode, row.locationId,
        row.cadastreId, row.activeMeterCount, row.sourceBuildingType, row.proposedBuildingTypeName,
        row.proposedBuildingTypeCode, locale.statuses[row.status] || row.status,
        locale.confidence[row.confidence] || row.confidence,
        locale.matchMethods[row.matchMethod] || row.matchMethod, '', ''
    ])];
}

export function downloadBuildingTypeBackfillProposal(rows: BuildingTypeBackfillProposalRow[]): void {
    const language = AppContext.getPreferredLanguage() === 'nl' ? 'nl' : 'en';
    const locale = labels[language];
    exportDataAsExcel(buildingTypeBackfillProposalRows(rows, language),
        `${locale.fileName}-${moment().format('YYYY-MM-DD')}.xlsx`);
}
